import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { HearingSegment } from '../../type/court';
import { Location } from '../location';
/**
 * A request for some part of the court record
 */
export class LineItem {
}
__decorate([
    Type(() => HearingSegment),
    __metadata("design:type", Array)
], LineItem.prototype, "hearingSegments", void 0);
__decorate([
    Type(() => Location),
    __metadata("design:type", Object)
], LineItem.prototype, "location", void 0);
